import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getUserSubscriptions,
  subscribeProject,
  unSubscribeProject
} from "@/models";
import { AppState } from "@/redux/store/store";
import { fetchAuthToken } from "@/helpers/fetch-auth-token";

export const fetchUserSubscriptions = createAsyncThunk(
  "userSubscriptions/fetchUserSubscriptions",
  async (params: { query?: any }, { getState, rejectWithValue }) => {
    try {
      const { adapter } = getState() as AppState;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());
      const { query } = params;

      const response = await getUserSubscriptions(token, baseUrl, {
        filterable: true,
        per_page: 5,
        page: 1,
        filters: { sort: { created_at: "desc" } },
        ...query
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const subscribe = createAsyncThunk(
  "userSubscriptions/subscribeProject",
  async (params: { projectId?: string }, { getState, rejectWithValue }) => {
    try {
      const { adapter, user, userSubscriptions } = getState() as AppState;
      const { subscriptions } = userSubscriptions;
      const { profile } = user.registeredUser;
      const { baseUrl } = adapter.adapter;
      const { email } = profile;
      const { projectId } = params;
      const { token } = fetchAuthToken(getState());

      await subscribeProject(token, baseUrl, projectId, { email });
      const response = subscriptions.map((subscription) => {
        if (subscription.id === projectId) {
          return { ...subscription, hideSubscription: false };
        }

        return subscription;
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const unSubscribe = createAsyncThunk(
  "userSubscriptions/unSubscribeProject",
  async (params: { projectId?: string }, { getState, rejectWithValue }) => {
    try {
      const { adapter, userSubscriptions } = getState() as AppState;
      const { subscriptions } = userSubscriptions;
      const { baseUrl } = adapter.adapter;
      const { token } = fetchAuthToken(getState());
      const { projectId } = params;

      await unSubscribeProject(token, baseUrl, projectId, {});
      const response = subscriptions.map((subscription) => {
        if (subscription.id === projectId) {
          return { ...subscription, hideSubscription: true };
        }

        return subscription;
      });

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
